/* Maison Hadid – Theme Script */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const R = window.maison?.routes || {};

  /* ---------- Drawers ---------- */
  function openDrawer(id) { const d = document.getElementById(id); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); if (opener.dataset.open === 'cart-drawer') renderCart(); openDrawer(opener.dataset.open); }
    const closer = e.target.closest('[data-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- Money ---------- */
  function money(cents) {
    const fmt = window.maison?.moneyFormat || 'CHF {{amount}}';
    const v = (cents / 100);
    const amount = v.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = v.toLocaleString('de-CH', { maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec).replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- Cart ---------- */
  async function getCart() { const r = await fetch((R.root || '/') + 'cart.js'); return r.json(); }
  function setCount(n) { $$('[data-cart-count]').forEach(el => el.textContent = n); }

  async function renderCart() {
    const body = $('#cart-drawer [data-cart-body]'); const foot = $('#cart-drawer [data-cart-foot]');
    if (!body) return;
    const cart = await getCart();
    setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<p class="h3 italic" style="margin-top:20px">Your bag is empty.</p><p class="note" style="margin-top:12px">Discover the new collection.</p>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(it => `
      <div class="line">
        <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : ''}" alt="${it.product_title}"></a>
        <div>
          <div class="line__title">${it.product_title}</div>
          ${it.variant_title ? `<div class="line__meta">Size ${it.variant_title}</div>` : ''}
          <div class="qty">
            <button type="button" data-qty="${it.key}" data-n="${it.quantity - 1}" aria-label="Decrease">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-qty="${it.key}" data-n="${it.quantity + 1}" aria-label="Increase">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="line__meta" style="color:var(--c-ink)">${money(it.final_line_price)}</div>
          <button class="remove" type="button" data-qty="${it.key}" data-n="0" style="margin-top:34px">Remove</button>
        </div>
      </div>`).join('');
    $('[data-cart-subtotal]').textContent = money(cart.total_price);
  }

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty]'); if (!b) return;
    b.disabled = true;
    await fetch(R.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.qty, quantity: +b.dataset.n }) });
    renderCart();
  });

  /* Add to cart (product form) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]'); const label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding …';
    try {
      const res = await fetch(R.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error((await res.json()).description || 'This piece could not be added. Please try again.');
      await renderCart(); openDrawer('cart-drawer');
    } catch (err) { const n = form.querySelector('[data-form-error]') || form.insertAdjacentElement('beforeend', Object.assign(document.createElement('p'), { className: 'note' })); n.setAttribute('data-form-error', ''); n.style.marginTop = '12px'; n.textContent = err.message; }
    btn.disabled = false; btn.innerHTML = label;
  });

  /* Variant selection on product page */
  const variantJson = $('[data-variants]');
  if (variantJson) {
    const variants = JSON.parse(variantJson.textContent);
    const idInput = $('form[data-product-form] input[name=id]');
    const price = $('[data-price]'); const btn = $('form[data-product-form] [type=submit]');
    $$('input[name=size]').forEach(r => r.addEventListener('change', () => {
      const v = variants.find(x => x.option1 === r.value); if (!v) return;
      idInput.value = v.id; if (price) price.textContent = money(v.price);
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }));
  }

  /* ---------- Wishlist (stored in the browser) ---------- */
  const WKEY = 'maison-wishlist';
  const readW = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch { return []; } };
  const writeW = (l) => { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch {} };
  function paintW() { const l = readW(); $$('[data-wish]').forEach(b => b.classList.toggle('is-on', l.includes(b.dataset.wish))); $$('[data-wish-count]').forEach(el => el.textContent = l.length); }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const l = readW(); const h = b.dataset.wish; const i = l.indexOf(h);
    i > -1 ? l.splice(i, 1) : l.push(h); writeW(l); paintW();
  });
  paintW();

  /* ---------- Carousels ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-scroll]'); if (!b) return;
    const track = b.closest('section').querySelector('[data-carousel]'); if (!track) return;
    track.scrollBy({ left: +b.dataset.scroll * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Sort select ---------- */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((en) => en.forEach(x => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('.reveal').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));

  /* ---------- Header hide on scroll ---------- */
  let lastY = 0; const header = $('[data-header]');
  const onScroll = () => { const y = scrollY; if (!header) return; header.classList.toggle('is-solid', y > 40); header.style.transform = (y > lastY && y > 400) ? 'translateY(-100%)' : ''; lastY = y; };
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
})();
